export const commonContent = {
  stewardshipCTA: "Join the Movement",
  viewCollection: "View the Collection",
  plantSeed: "Plant Your Seed",
  shopAlphabet: "Shop the Alphabet",
  learnMission: "Learn Our Mission",
  joinCommunity: "Join the Movement",
  joinMovement: "Join the Movement"
};